module.exports = __webpack_public_path__ + "static/bbis-boiler-cf10447cf44a603d73a56a0d03b17f0d.jpeg";